import { browserHistory } from 'react-router'
import 'isomorphic-fetch'
export const LOGIN = 'LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'

import mustConfirm from '../utils/must-confirm'

export function login(values, redirect_uri) {
  if(redirect_uri) {
    values['redirect_after_auth'] = redirect_uri
    values['redirect_uri'] = redirect_uri
  }
  console.log('values from actions', values);
  return dispatch => {
    dispatch({ type: LOGIN })
    fetch('/login', {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify(values),
      headers: new Headers({
         'Content-Type': 'application/json',
         Accept: 'application/json',
       })
    })
    .then(response => {
      if (!response.ok) {
        return dispatch({ type: POST_DETAILS_ERROR, err: response.statusText })
      }
      return response;
    })
    .then(response => {
      console.log('response from login action', response)
      if (response.status > 299) {
        dispatch({ type: LOGIN_ERROR, err: "Login Error" })
      } else {
        return response.json()
      }
    })
    .then(json => {
      console.log('json from login actions', json);
      if (json.err) {
        dispatch({ type: LOGIN_ERROR, err: json.err })
      } else {
        dispatch({ type: LOGIN_SUCCESS, user: json.user })
        browserHistory.push('/otp')
      }
    })
    .catch(err => dispatch({ type: LOGIN_ERROR, err: err.toString() }))
  }
}

export const LOGOUT = 'LOGOUT'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_ERROR = 'LOGOUT_ERROR'

export const REDIRECTING = 'REDIRECTING'

export function logout() {
  return dispatch => {
    // we log out by (a) a REST call to /logout, then (b) redirecting to /logout
    // this seems unnecessary, but session handling is a bit unclear here,
    // and this way we are certain that the user session gets destroyed
    // either way, effectively logging the user out
    dispatch({ type: LOGOUT })
    fetch('/logout')
    .then(response => response.json())
    .then(json => {
      console.log('json response from logout', json)
      dispatch({ type: REDIRECTING })
      window.location = '/logout'
    })
  }
}
export const POST_OTP = 'POST_OTP'
export const POST_OTP_SUCCESS = 'POST_OTP_SUCCESS'
export const POST_OTP_ERROR = 'POST_OTP_ERROR'

export function postOtp(values) {
  console.log('values from postOtp', values);
  return dispatch => {
    dispatch({ type: POST_OTP, otp: values.otp })
    fetch('/otp', {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify(values),
      headers: new Headers({
         'Content-Type': 'application/json',
         Accept: 'application/json',
       })
    })
    .then(response => response.json())
    .then(json => {
      if(json.err) {
        dispatch({ type: POST_OTP_ERROR, err: json.err })
      } else {
        json.redirect_uri = json.redirect_uri ? json.redirect_uri : '/'
        dispatch({
          type: POST_OTP_SUCCESS,
          user: json.user,
          redirect_uri: json.redirect_uri
        })

        if (json.user.hasEmail) {

          if(mustConfirm(json.user)) {
            browserHistory.push('/confirm-email')
          } else if (json.redirect_uri) {
            dispatch({ type: REDIRECTING })
            window.location = json.redirect_uri
          }

        } else {
          browserHistory.push('/provide-details')
        }
      }
    })
  }
}

export const PRIMARY_EMAIL_CONFIRMED = 'PRIMARY_EMAIL_CONFIRMED'
export const PRIMARY_EMAIL_CONFIRMED_SUCCESS = 'PRIMARY_EMAIL_CONFIRMED_SUCCESS'
export const PRIMARY_EMAIL_CONFIRMED_ERROR = "PRIMARY_EMAIL_CONFIRMED_ERROR"

export function primaryEmailConfirmed(redirectUriAfterLogin) {
  return dispatch => {
    dispatch({ type: PRIMARY_EMAIL_CONFIRMED })
    fetch('/confirm-primary-email', {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({
         'Content-Type': 'application/json',
         Accept: 'application/json',
       })
    })
    .then(response => {
      if (response > 299) {
        dispatch({ type: PRIMARY_EMAIL_CONFIRMED_ERROR, err: "Unable to confirm email"})
        console.log('Unable to confirm email: ', response)
        alert('Unable to confirm email: ' + response)
      } else {
        return response.json()
      }
    })
    .then(json => {
      dispatch({ type: PRIMARY_EMAIL_CONFIRMED_SUCCESS })
      dispatch({ type: REDIRECTING })
      window.location = redirectUriAfterLogin
    })
    .catch(err => {
      console.log('Unable to confirm email', err)
      alert('Unable to confirm email, please try again.')
    })
  }
}

export const EMAIL_OTP = 'EMAIL_OTP'
export const EMAIL_OTP_SUCCESS = 'EMAIL_OTP_SUCCESS'
export const EMAIL_OTP_ERROR = "EMAIL_OTP_ERROR"

export function emailOtp() {
  return dispatch => {
    dispatch({ type: EMAIL_OTP })
    fetch('/email-otp', {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({
         'Content-Type': 'application/json',
         Accept: 'application/json',
       })
    })
    .then(response => {
      if (response.status > 299) {
        dispatch({ type: EMAIL_OTP_ERROR, err: "Error sending OTP as email"})
      } else {
        return response.json()
      }
    })
    .then(json => {
      console.log('json from emailOtp', json)
      if(json && json.msg) {
        dispatch({ type: EMAIL_OTP_SUCCESS, msg: json.msg })
      }
    })
  }
}

export const RESEND_SMS = 'RESEND_SMS'
export const RESEND_SMS_SUCCESS = 'RESEND_SMS_SUCCESS'
export const RESEND_SMS_ERROR = "RESEND_SMS_ERROR"

export function resendSms() {
  return dispatch => {
    dispatch({ type: RESEND_SMS })
    fetch('/resend-sms', {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({
         'Content-Type': 'application/json',
         Accept: 'application/json',
       })
    })
    .then(response => {
      console.log('response from resend sms', response)
      if (response.status > 299) {
        dispatch({ type: RESEND_SMS_ERROR, err: "Error sending SMS"})
      } else {
        return response.json()
      }
    })
    .then(json => {
      console.log('json from resend sms', json)
      dispatch({ type: RESEND_SMS_SUCCESS, msg: json.msg })
    })
  }
}

export const POST_DETAILS = 'POST_DETAILS'
export const POST_DETAILS_SUCCESS = 'POST_DETAILS_SUCCESS'
export const POST_DETAILS_ERROR = 'POST_DETAILS_ERROR'

export function postDetails(values) {
  console.log('values from post details action', values);
  return dispatch => {
    dispatch({ type: POST_DETAILS })
    fetch('/details', {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify(values),
      headers: new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json'
      })
    })
    .then(response => {
      if (!response.ok) {
        return dispatch({ type: POST_DETAILS_ERROR, err: response.statusText })
      }
      return response;
    })
    .then(response => response.json())
    .then(json => {
      if (json.err) {
        dispatch({ type: POST_DETAILS_ERROR, err: json.err })
      } else {
        dispatch({ type:  POST_DETAILS_SUCCESS, user: json.user })
        dispatch({ type: REDIRECTING })
        window.location = json.redirect_uri
      }

    })
  }
}

export const VIEW_AS_ADMIN = 'VIEW_AS_ADMIN'
export const VIEW_AS_ADMIN_SUCCESS = 'VIEW_AS_ADMIN_SUCCESS'
export const VIEW_AS_ADMIN_ERROR = 'VIEW_AS_ADMIN_ERROR'
// TODO: Complete viewAsAdmin
export function viewAsAdmin(sub) {
  return dispatch => {
    dispatch({ type: VIEW_AS_ADMIN })
    fetch(`/view-as-admin/${sub}`, {
      credentials: 'same-origin',
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json'
      })
    })
    .then(response => response.json())
    .catch(err => {
      dispatch({ type: VIEW_AS_ADMIN_ERROR, err: err })
      throw err
    })
    .then(json => {
      if (json.error) {
        // alert('Unable to view user: ' + json.error)
        return dispatch({ type: VIEW_AS_ADMIN_ERROR, err: json.error })
      }
      dispatch({ type: VIEW_AS_ADMIN_SUCCESS, user: json.user })
    })
  }
}

export const GET_EMAILS = "GET_EMAILS"
export const RECEIVE_EMAILS = "RECEIVE_EMAILS"

const emailsQuery = `query {
  user {
    email,
    emails {
      email,
      isVerified
    }
  }
}`
export function fetchEmails() {
  return dispatch => {
    dispatch({ type: GET_EMAILS })
    fetch('/api?query=' + emailsQuery, {
      credentials: 'same-origin',
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json'
      })
    })
    .then(response => response.json())
    .catch(err => {
      alert('Unable to load emails: ' + err.message)
      browserHistory.push('/')
      throw err
    })
    .then(json => {
      console.log('results from multiple emails', json);
      dispatch({ type: RECEIVE_EMAILS, emails: json.data.user.emails, email: json.data.user.email })
    })
  }
}

export const ADD_EMAIL = "ADD_EMAIL"
export const ADD_EMAIL_SUCCESS = "ADD_EMAIL_SUCCESS"
export const ADD_EMAIL_ERROR = "ADD_EMAIL_ERROR"

const addEmailMutation = `mutation($email:String!) {
  addEmail(email: $email) {
    emails {
      email,
      isVerified
    }
  }
}`
 export function addEmail(email) {
   return dispatch => {
     dispatch({ type: ADD_EMAIL })
     fetch('/api?query=' + addEmailMutation + '&variables=' + encodeURIComponent(JSON.stringify(email)), {
       credentials: 'same-origin',
       method: 'POST',
       headers: new Headers({
         Accept: 'application/json'
       })
     })
     .then(response => (response.json()))
     .then(json => {
       if(json && json.errors && json.errors.length > 0) {
         dispatch({type: ADD_EMAIL_ERROR, err: json.errors[0].message})
       } else {
         console.log('data from addEMail',json.data);
          dispatch({ type: ADD_EMAIL_SUCCESS, emails: json.data.addEmail.emails })
       }
     })
   }
 }

export const DELETE_EMAIL = "DELETE_EMAIL"
export const DELETE_EMAIL_SUCCESS = "DELETE_EMAIL_SUCCESS"
export const DELETE_EMAIL_ERROR = "DELETE_EMAIL_ERROR"

const deleteEmailMutation = `mutation($email:String!) {
  deleteEmail(email: $email) {
    email,
    emails {
     email,
     isVerified
   }
  }
}`

export function deleteEmail(email) {
  return dispatch => {
    dispatch({ type: DELETE_EMAIL })
    fetch('/api?query=' + deleteEmailMutation + '&variables=' + encodeURIComponent(JSON.stringify(email)), {
      credentials: 'same-origin',
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json'
      })
    })
    .then(response => (response.json()))
    .then(json => {
      if(json && json.errors && json.errors.length > 0) {
        dispatch({type: DELETE_EMAIL_ERROR, err: json.errors[0].message})
      } else {
        console.log('data from delete emails', json.data);
        dispatch({ type: DELETE_EMAIL_SUCCESS, emails: json.data.deleteEmail.emails, email: json.data.deleteEmail.email })
      }
    })
  }
}

export const MAKE_DEFAULT = "MAKE_DEFAULT"
export const MAKE_DEFAULT_SUCCESS = "MAKE_DEFAULT_SUCCESS"
export const MAKE_DEFAULT_ERROR = "MAKE_DEFAULT_ERROR"

const makeDefaultMutation = `mutation($email:String!) {
  makePrimary(email: $email) {
    email,
    primaryEmailConfirmedAt,
    emails {
     email,
     isVerified
   }
  }
}`

export function makeDefault(email) {
  return dispatch => {
    dispatch({ type: MAKE_DEFAULT })
    fetch('/api?query=' + makeDefaultMutation + '&variables=' + encodeURIComponent(JSON.stringify(email)), {
      credentials: 'same-origin',
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json'
      })
    })
    .then(response => (response.json()))
    .then(json => {
      console.log('response from makeDefault', json.data);
      if(json && json.errors && json.errors.length > 0) {
        dispatch({type: MAKE_DEFAULT_ERROR, err: json.errors[0].message})
      } else {
        dispatch({type: MAKE_DEFAULT_SUCCESS, emails: json.data.makePrimary.emails, email: json.data.makePrimary.email })
      }
    })
  }
}

export const SEND_VERIFICATION = "SEND_VERIFICATION"
export const SEND_VERIFICATION_SUCCESS = "SEND_VERIFICATION_SUCCESS"
export const SEND_VERIFICATION_ERROR = "SEND_VERIFICATION_ERROR"

const sendVerificationMutation = `mutation($email:String!) {
  requestVerificationEmail(email: $email)
}`

export function sendVerification(email) {
  return dispatch => {
    dispatch({ type: SEND_VERIFICATION })
    fetch('/api?query=' + sendVerificationMutation + '&variables=' + encodeURIComponent(JSON.stringify(email)), {
      credentials: 'same-origin',
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json'
      })
    })
    .then(response => (response.json()))
    .then(json => {
      if (json && json.errors && json.errors.length > 0) {
        dispatch({ type: SEND_VERIFICATION_ERROR, err: json.errors[0].message })
      } else {
        dispatch({ type: SEND_VERIFICATION_SUCCESS, msg: 'Verification email sent' })
      }
    })
  }
}

export const SHOW_RESEND = "SHOW_RESEND"

export function showResend() {
  return dispatch => {
    setTimeout(() => {
      dispatch({ type: SHOW_RESEND })
    }, 15 * 1000)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/login-actions.js